import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% { opacity: 0; transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
`;

const fadeOut = keyframes`
  0% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(0.9); }
`;

const ModalWrapper = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: ${({ show }) => (show ? fadeIn : fadeOut)} 0.3s ease-out;
`;

const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
`;

const IconWrapper = styled.div<{ type: 'aprovado' | 'recusado' | 'pendente' }>`
  width: 80px;
  height: 80px;
  margin: 0 auto 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ type }) => (type === 'aprovado' ? '#eaf9e5' : type === 'recusado' ? '#f9e5e5' : '#faeabb')};
  border: 2px solid ${({ type }) => (type === 'aprovado' ? '#b8e2b3' : type == 'recusado' ? '#e2b3b3': '#decd9b')};
`;

const Icon = styled.span<{ type: 'aprovado' | 'recusado' | 'pendente' }>`
  font-size: 50px;
  color: ${({ type }) => (type === 'aprovado' ? '#4caf50' :type === 'recusado' ? '#e74c3c' : '#FFC107')};
`;

const Title = styled.h2`
  font-size: 22px;
  color: #333;
  margin: 10px 0;
`;

const Message = styled.p`
  font-size: 16px;
  color: #555;
`;

const Button = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background: #00aef0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #008ecf;
  }
`;

interface ModalProps {
  show: boolean;
  type: 'aprovado' | 'recusado' | 'pendente';
  messageAviso: string;
  onClose: () => void;
}

const ModalAviso: React.FC<ModalProps> = ({ show, type, messageAviso, onClose }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setVisible(true);
    } else {
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  return (
    <ModalWrapper show={visible}>
      <ModalContent>
        <IconWrapper type={type}>
          <Icon type={type}>{type === 'aprovado' ? '✓' : type == 'recusado' ? 'X' : '⏳'}</Icon>
        </IconWrapper>
        <Title>{type === 'aprovado' ? 'Parabéns :)' : type == 'recusado' ? 'Ops :(' : 'Aguarde'}</Title>
        <Message>{messageAviso}</Message>
        <Button type="button" onClick={onClose}>Entendi</Button>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ModalAviso;